import { Popover } from '@headlessui/react';

interface ProgressPopoverProps {
  progressDiff: number;
  previousProgress: number;
  currentProgress: number;
}

export function ProgressPopover({
  progressDiff,
  previousProgress,
  currentProgress,
}: ProgressPopoverProps): JSX.Element {
  return (
    <Popover.Panel
      static
      className="absolute z-20 px-4 py-2 text-sm bg-white rounded-md shadow-md -top-24 left-1/2 transform -translate-x-1/2 border border-gray-200 min-w-[240px]"
    >
      <div className="space-y-2">
        <div className="flex justify-between gap-8">
          <span className="text-gray-500">Progress Achieved:</span>
          <span
            className={progressDiff < 0 ? 'text-red-600' : 'text-green-600'}
          >
            {progressDiff > 0 ? '+' : ''}
            {progressDiff}%
          </span>
        </div>
        <div className="flex justify-between gap-8">
          <span className="text-gray-500">Previous Progress:</span>
          <span className="text-gray-900">{previousProgress}%</span>
        </div>
        <div className="flex justify-between gap-8">
          <span className="text-gray-500">Total Progress:</span>
          <span className="text-gray-900">{currentProgress}%</span>
        </div>
      </div>
    </Popover.Panel>
  );
}
